var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner charge-scheme-batch-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1095px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "125px", "label-position": "left" } },
            [
              !_vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ProductName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.schemeName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "schemeName", $$v)
                                  },
                                  expression: "form.schemeName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                              }
                            },
                            [
                              _c("cargo-sales-company-select", {
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "method-params": { customer: true },
                                  "clear-not-match": true,
                                  "default-value":
                                    _vm.form.customer == 0
                                      ? ""
                                      : _vm.form.customer
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.customer = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BookingAgent")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "method-params": { bookingAgent: true },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.form.bookingAgent == 0
                                      ? ""
                                      : _vm.form.bookingAgent
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.bookingAgent = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Carrier") }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.seCarrier == 0
                                      ? ""
                                      : _vm.form.seCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.seCarrier = p.cmpIdx)
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.aiCarrier == 0
                                      ? ""
                                      : _vm.form.aiCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.aiCarrier = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_FLCLType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.chkMatch },
                                  model: {
                                    value: _vm.form.containerLoadType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "containerLoadType",
                                        $$v
                                      )
                                    },
                                    expression: "form.containerLoadType"
                                  }
                                },
                                _vm._l(_vm.containerLoadTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CargoType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value": _vm.form.cargoType,
                                  "callback-params": { key: "cargoType" },
                                  "options-width": "150px;"
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.PortOfLoading")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.txtSeaLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaLoadingPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtAirLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirLoadingPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DestinationPort")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtSeaDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaDestinationPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtAirDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirDestinationPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DestinationAgent")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.chkMatch,
                                  "tag-name": "englishName",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { overseaAgent: true },
                                  "default-value":
                                    _vm.form.txtDestAgent == 0
                                      ? ""
                                      : _vm.form.txtDestAgent
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.txtDestAgent = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Airline") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  "callback-params": { key: "txtServiceLine" },
                                  "callback-method-type": "value",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtServiceLine
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.job && _vm.job.fba
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.FeeName") }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.chkMatch,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeItem,
                                      "default-value":
                                        _vm.form.chargeItemId === 0
                                          ? ""
                                          : _vm.form.chargeItemId
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.chargeItemId =
                                          p.itemId)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.source === "tabCharges"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("Pricing.BeginDate") }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value: _vm.form.effectiveDateStart,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "effectiveDateStart",
                                              $$v
                                            )
                                          },
                                          expression: "form.effectiveDateStart"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            "margin-left": "1px",
                                            "margin-right": "1px"
                                          }
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value: _vm.form.effectiveDateEnd,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "effectiveDateEnd",
                                              $$v
                                            )
                                          },
                                          expression: "form.effectiveDateEnd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.NominatedAgent")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    designationAgent: true,
                                    active: true
                                  },
                                  "default-value":
                                    _vm.form.txtNominatedAgent == 0
                                      ? ""
                                      : _vm.form.txtNominatedAgent
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.txtNominatedAgent =
                                      p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.source !== "tabCharges"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BillExchangeAgent")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.chkMatch,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": {
                                        bookingAgent: true,
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.txtExchangeAgent == 0
                                          ? ""
                                          : _vm.form.txtExchangeAgent
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.txtExchangeAgent =
                                          p.cmpIdx)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _vm.source === "operateBillDialog"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_PaymentReceiveMethod"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.receivableDisable,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_ChangeChargeConstant$CHANGE_CHARGE_CHARGETYPE,
                                      "default-value": _vm.form.receivable
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.receivable = p.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.source === "tabCharges"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BillExchangeAgent")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.chkMatch,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": {
                                        bookingAgent: true,
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.txtExchangeAgent == 0
                                          ? ""
                                          : _vm.form.txtExchangeAgent
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.txtExchangeAgent =
                                          p.cmpIdx)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          attrs: {
                            span: 8,
                            offset:
                              _vm.source !== "tabCharges" &&
                              _vm.source !== "operateBillDialog"
                                ? 8
                                : 0
                          }
                        },
                        [
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.source !== "jobList",
                                        expression: "source !== 'jobList'"
                                      }
                                    ],
                                    on: { change: _vm.chkMatch_changeHandler },
                                    model: {
                                      value: _vm.chkMatch,
                                      callback: function($$v) {
                                        _vm.chkMatch = $$v
                                      },
                                      expression: "chkMatch"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Autowire")))]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "custom" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toQuery(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.resetHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ProductName")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.schemeName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "schemeName", $$v)
                                  },
                                  expression: "form.schemeName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                              }
                            },
                            [
                              _c("cargo-sales-company-select", {
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "method-params": { customer: true },
                                  "clear-not-match": true,
                                  "default-value":
                                    _vm.form.customer == 0
                                      ? ""
                                      : _vm.form.customer
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.customer = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Carrier") }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.seCarrier == 0
                                      ? ""
                                      : _vm.form.seCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.seCarrier = p.cmpIdx)
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.aiCarrier == 0
                                      ? ""
                                      : _vm.form.aiCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.aiCarrier = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_FLCLType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.chkMatch },
                                  model: {
                                    value: _vm.form.containerLoadType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "containerLoadType",
                                        $$v
                                      )
                                    },
                                    expression: "form.containerLoadType"
                                  }
                                },
                                _vm._l(_vm.containerLoadTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CargoType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value": _vm.form.cargoType,
                                  "callback-params": { key: "cargoType" },
                                  "options-width": "150px;"
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.PortOfLoading")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.txtSeaLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaLoadingPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtAirLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirLoadingPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DestinationPort")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtSeaDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaDestinationPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.chkMatch,
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtAirDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirDestinationPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Airline") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  disabled: _vm.chkMatch,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  "callback-params": { key: "txtServiceLine" },
                                  "callback-method-type": "value",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtServiceLine
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.job && _vm.job.fba
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.FeeName") }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.chkMatch,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeItem,
                                      "default-value":
                                        _vm.form.chargeItemId === 0
                                          ? ""
                                          : _vm.form.chargeItemId
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.chargeItemId =
                                          p.itemId)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.source === "tabCharges"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("Pricing.BeginDate") }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value: _vm.form.effectiveDateStart,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "effectiveDateStart",
                                              $$v
                                            )
                                          },
                                          expression: "form.effectiveDateStart"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            "margin-left": "1px",
                                            "margin-right": "1px"
                                          }
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value: _vm.form.effectiveDateEnd,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "effectiveDateEnd",
                                              $$v
                                            )
                                          },
                                          expression: "form.effectiveDateEnd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.saleRoleHide
                ? _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _vm.source !== "tabCharges"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.BillExchangeAgent")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "options-width": "150px;",
                                      disabled: _vm.chkMatch,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      "method-params": {
                                        bookingAgent: true,
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.txtExchangeAgent == 0
                                          ? ""
                                          : _vm.form.txtExchangeAgent
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        return (_vm.form.txtExchangeAgent =
                                          p.cmpIdx)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        {
                          attrs: {
                            span: 8,
                            offset: _vm.source !== "tabCharges" ? 8 : 0
                          }
                        },
                        [
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.source !== "jobList",
                                        expression: "source !== 'jobList'"
                                      }
                                    ],
                                    on: { change: _vm.chkMatch_changeHandler },
                                    model: {
                                      value: _vm.chkMatch,
                                      callback: function($$v) {
                                        _vm.chkMatch = $$v
                                      },
                                      expression: "chkMatch"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Autowire")))]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "custom" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toQuery(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.resetHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "min-height": "350px", padding: "0" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "370px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "config-module": "1301011",
              "deselect-sub-record": true
            },
            on: { gridReady: _vm.onGridReady }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("cargo-pagination", {
            attrs: {
              "config-module": "1301011",
              total: _vm.total,
              page: _vm.pageNum,
              limit: _vm.pageSize
            },
            on: {
              "update:page": function($event) {
                _vm.pageNum = $event
              },
              "update:limit": function($event) {
                _vm.pageSize = $event
              },
              pagination: function($event) {
                return _vm.toQuery()
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.selectHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }